const HOME = {
  POLICY_CORPORATE_PORTFOLIO: 'Policy Corporate Portfolio',
  POLICY_PORTFOLIO: 'Policy Portfolio',
  ADD_AN_EXISTING_POLICY: 'ADD AN EXISTING POLICY',
  VIEWALL: 'ViewAll',
  BUY_A_POLICY: ' Buy a Policy',
  RENEW_YOUR_POLICY: 'Renew your Policy',
  REGISTER_A_CLAIM: 'Register a Claim',
  REGISTER_A_CLAIM_BUTTON: 'Register a claim',
  RISK_ANALYSIS_REPORT: 'Risk Analysis Report',
  PAISAPLAN_FEATURES: 'PaisaPlan Features',
  CREATE_YOUR_PORTFOLIO: 'Create Your Portfolio',
  GET_COMPARTIVE_QUOTES: 'Get compartive quotes',
  CLAIM_ASSISTANCE: 'Claim Assistance',
  CHOOSE_YOUR_COVERAGE: 'Choose your coverage',
  UNBIASED_ADVISORY: 'unBiased Advisory',
  AADD_AN_EXISTING_POLICY: 'Add an Existing Policy',
  UPLOAD_YOUR_POLICY_DOCUMENT: 'Upload your Policy document',
  TROVITY_WILL_SIMPLIFY: 'Trovity will simplify',
  IT_WILL_SHOW_LIKE_THIS: 'It will show like this',
  UPLOAD_YOUR_POLICY_DETAILS_MANUALLY: 'Upload your Policy Details Manually',
  PROCEED: 'Proceed',
  INSURANCE_PORTAL: 'Insurance portal',
  WELCOME_BACK: 'Welcome back',
  ACTIVE_STATE: 'ACTIVE',
  ACTIVE_SMALL: 'Active',
  VERIFICATION_PENDING_STATE: 'VERIFICATION_PENDING',
  DOCUMENT_REQUIRED_STATE: 'DOCUMENT_REQUIRED',
  INVALID_DOCUMENT_STATE: 'INVALID_DOCUMENT',
  VERIFICATION_PENDING: 'VERIFICATION PENDING',
  VERIFICATION_PENDING_SMALL: 'Verification Pending',
  DOCUMENT_REQUIRED: 'DOCUMENT REQUIRED',
  INVALID_DOCUMENT: 'INVALID DOCUMENT',
  UPLOAD_POLICY: 'UPLOAD POLICY',
  UPLOAD_POLICY_SMALL: 'Upload Policy',
  DIGITALIZING: 'DIGITALIZING',
  PREMIUM_PAID: 'Premium Paid',
  EXPIRY_DATE: 'Expiry date',
  CLAIMS: 'Claims',
  SUM_ASSURED: 'Sum Assured',
  ENDORSEMENT: 'Endorsement',
  INDIVIDUAL: 'INDIVIDUAL',
  RENEW_POLICY: 'Renew policy',
  NEAR_TO_EXPIRE: 'Near to expire',
  EXPIRED: 'Expired',
  SEEMS_LIKE_YOU_LANDED: 'Seems like you landed on the wrong page.',
  LOGOUT: 'LogOut',
  FORBIDDEN_USER_TEXT:
    'Forbidden User. Please login with your new account credentials.',
}
export { HOME }
